import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { getContactsAsync, submitContactFormAsync } from "./actions";
import { IContactUsState } from "./slice";

type Reducer = (builder: ActionReducerMapBuilder<IContactUsState>) => void;

export const submitContactFormReducer: Reducer = (builder) => {
  builder.addCase(submitContactFormAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(submitContactFormAsync.fulfilled, (state) => {
    state.isLoading = false;
  });

  builder.addCase(submitContactFormAsync.rejected, (state) => {
    state.isLoading = false;
  });
};

export const getContactListReducer: Reducer = (builder) => {
  builder.addCase(getContactsAsync.pending, (state) => {
    state.isLoadingContacts = true;
  });

  builder.addCase(getContactsAsync.fulfilled, (state, actions) => {
    state.isLoadingContacts = false;
    state.contacts = actions.payload;
  });

  builder.addCase(getContactsAsync.rejected, (state) => {
    state.isLoadingContacts = false;
  });
};
